export default {
  rentalSteps: {
    NOT_STARTED: 'Not Started',
    PREPARING_VEHICLE: 'Preparing Vehicle',
    FINISHED: 'Finished',
    CANCELED: 'Cancelled',
    WAITING_RENTAL_START: 'Waiting Rental Start',
    VEHICLE_ON_DELIVERY: 'Vehicle on Delivery',
    RENTAL_IN_PROGRESS: 'Active',
    WAITING_CUSTOMER_TO_VEHICLE: 'Waiting Customer',
    WAITING_PAYMENT: 'Waiting Payment',
    WAITING_RENTAL_END: 'Waiting Rental End',
  },
  planning: {
    title: 'Planning',
    noStatusMatch: 'No rentals matching the selected status',
    vehicle: 'Vehicle',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    continuesBefore: 'Continues from the previous day',
    continuesAfter: 'Continues on the next day',
    outOfService: 'Out of Service · {reason}',
    outOfServiceUntil: 'Out of Service until {until} · {reason}',
    popup: {
      details: 'Details',
      openDetails: 'Rental details',
    },
  },
  newRequest: {
    title: 'New flexiCar Request',
    summary: 'Reserving {vehicle}',
    lookupsFailed: 'Some form options could not be loaded. Close the form and try again.',
    pickup: 'Pick-up',
    dropoff: 'Drop-off',
    driver: 'Driver Name',
    driverPlaceholder: 'Select driver',
    driverNoResults: 'No driver matches your search.',
    driverNoOptions: 'No drivers to choose from.',
    passengers: 'Number of Passengers',
    passengersUpdated: 'Passenger count updated to match added drivers',
    destination: 'Destination',
    destinationPlaceholder: 'Search a place',
    destinationFailed: 'This place could not be found. Search for another one.',
    reason: 'Rental Reason',
    reasonPlaceholder: 'Select reason',
    reasonTextPlaceholder: 'Enter reason',
    explanation: 'Explanation',
    explanationPlaceholder: 'Explain rental reason',
    costCenter: 'Cost Center',
    costCenterPlaceholder: 'Select cost center',
    rentalType: 'Rental Type',
    rentalTypeHint: 'Select a driver and times to see the rental type.',
    additional: {
      add: '+ Additional Driver',
      rowLabel: 'Additional Driver {n} Phone Number',
      phonePlaceholder: 'Phone number',
      addButton: 'ADD DRIVER',
      cancel: 'CANCEL',
      remove: 'Remove driver',
      notFound: {
        title: 'No Matching Drivers',
        message: 'No users found with this phone number.',
        check: 'Check phone number',
        cancel: 'Cancel Adding Driver',
      },
      duplicate: {
        title: 'Driver Already Added',
        message: 'You already added a driver with this phone number.',
        close: 'Close',
      },
    },
    cancel: 'Cancel',
    reserve: 'Reserve',
    validation: {
      required: 'This field is required.',
      pickupTooEarly: 'Pick-up can be {time} at the earliest.',
      dropoffBeforePickup: 'Drop-off must be after pick-up.',
      passengersMax: 'At most {max} passengers.',
    },
    created: 'Reservation created for {driver}.',
    errors: {
      leadTime: 'Pick-up must be at least {minutes} minutes from now.',
      overlap: 'The driver already has a reservation at these times.',
      vehicleUnavailable: "This vehicle can't be booked for these times. Try another time or vehicle.",
      notAllowed: "You can't make a reservation for this driver or at this vehicle's parking lot.",
      noOrganization: "This driver isn't in a company organization.",
      costCenter: 'This cost center is no longer available. Select another one.',
      generic: 'The reservation could not be created.',
    },
  },
  rentals: {
    title: 'Rentals',
    refresh: 'Refresh',
    lastUpdated: 'Last updated',
    vehicleFilter: 'Vehicle',
    removeFilter: 'Remove filter',
    noRentals: 'No rentals on selected dates',
    loadFailed: 'Rentals could not be loaded.',
    noPermission: "You don't have permission for this action.",
    statusChanged: 'The status of this rental changed while you were taking this action (now: {status}).',
    statuses: {
      REQUESTED: 'Requested',
      RESERVED: 'Reserved',
      DECLINED: 'Declined',
      CANCELED_BY_RIDER: 'Canceled by Rider',
      CANCELED_BY_ADMIN: 'Canceled by Admin',
      CANCELED_BY_SYSTEM: 'Canceled by System',
      ACTIVE: 'Active',
      OVERDUE: 'Overdue',
      COMPLETED_ON_TIME: 'Completed on Time',
      RETURNED_LATE: 'Returned Late',
      ENDED_BY_ADMIN: 'Ended by Admin',
    },
    columns: {
      vehicle: 'Vehicle',
      driver: 'Driver',
      additionalDrivers: 'Additional Driver(s)',
      status: 'Status',
      reason: 'Reason',
      explanation: 'Explanation',
      pickupLocation: 'Pick-up Location',
      plannedPickup: 'Planned Pick-up Time',
      actualPickup: 'Actual Pick-up Time',
      dropoffLocation: 'Drop-off Location',
      plannedDropoff: 'Planned Drop-off Time',
      actualDropoff: 'Actual Drop-off Time',
      destination: 'Destination',
      startingMileage: 'Starting Mileage',
      endingMileage: 'Ending Mileage',
      totalDistance: 'Total Distance ({unit})',
      totalDuration: 'Total Actual Duration',
      totalCost: 'Total Actual Cost ({currency})',
      rentalModel: 'Rental Model',
      drivingNotices: 'Driving Notices',
      internalDamage: 'New Internal Damage Reported',
      outerDamage: 'New Outer Damage Reported',
      reservedBy: 'Reserved by',
      approver: 'Approver',
      adminNote: 'Admin Note',
      canceledEndedBy: 'Canceled/Ended By',
      costCenter: 'Cost Center',
      history: 'Rental History',
      actions: 'Actions',
    },
    systemApprover: 'System',
    rentalModels: {
      pool: 'Standard',
      poolCalendarDaily: 'Daily',
    },
    durationUnits: {
      day: 'd',
      hour: 'h',
      minute: 'm',
    },
    actions: {
      approve: 'Approve',
      delete: 'Delete',
      endRental: 'End Rental',
    },
    dialog: {
      approveTitle: 'Approve Rental Request',
      approveMessage: 'Would you like to approve the car rental request by {driver}?',
      approve: 'Approve',
      decline: 'Decline',
      confirmDecline: 'Confirm Decline',
      declineReason: 'Decline reason',
      deleteTitle: 'Delete Reservation',
      deleteMessage: 'Are you sure you want to delete the vehicle reservation for {driver}?',
      delete: 'Delete',
      endTitle: 'End Rental',
      endMessage: 'Are you sure you want to end the active rental for {driver}?',
      endRental: 'End Rental',
      reason: 'Reason',
      cancel: 'Cancel',
      approved: 'The rental request was approved.',
      declined: 'The rental request was declined.',
      deleted: 'The reservation was deleted.',
      ended: 'The rental was ended.',
      failed: 'The action could not be completed.',
    },
    changeVehicle: {
      title: 'Change Vehicle',
      message: 'Are you sure you want to change the vehicle for this rental from {from} to {to}?',
      change: 'Change',
      noVehicles: 'No available vehicles',
      loadFailed: 'Available vehicles could not be loaded.',
      changed: 'The vehicle was changed.',
      rentalNotFound: 'This rental could not be found.',
      vehicleUnavailable: 'This vehicle is no longer available for this rental. Please choose another one.',
    },
    details: {
      title: 'Rental Details',
      tabs: {
        history: 'History',
        map: 'Map',
        notices: 'Driving Notices',
        damages: 'New Damages Reported',
        parking: 'Parking Information',
      },
      loadFailed: 'Rental details could not be loaded.',
      noDrivingNotices: 'No driving notices',
      noticeTypes: {
        HARSH_BRAKE: 'Harsh Brake',
        SPEED_LIMIT_EXCEEDED: 'Speed Limit Exceeded',
        HARSH_ACCELERATION: 'Harsh Acceleration',
        HARSH_CORNERING: 'Harsh Cornering',
      },
      map: {
        noData: 'No location data for this rental',
        loadFailed: 'The route could not be loaded.',
        stop: 'Stop {number}',
      },
      damages: {
        internalTitle: 'New Internal Damage Reported',
        outerTitle: 'New Outer Damage Reported',
        viewAll: 'View All ({count})',
        atPickup: 'At Pick-up ({count})',
        atDropoff: 'At Drop-off ({count})',
        loadFailed: 'Damages could not be loaded.',
      },
      parking: {
        front: 'Front View',
        back: 'Back View',
        left: 'Left View',
        right: 'Right View',
        photoCaption: 'Parked Vehicle Photo',
        notAvailable: 'Not available yet',
        noPhotos: 'No parking photos',
      },
      links: {
        viewDamages: 'View Damages',
        viewParkingInfo: 'View Parking Info',
      },
    },
    history: {
      vehicle: 'Vehicle',
      driver: 'Driver',
      rentalModel: 'Rental Model',
      status: 'Status',
      adminNote: 'Admin Note',
      plannedActualPickup: 'Planned / Actual Pick-up',
      plannedActualDropoff: 'Planned / Actual Drop-off',
      distanceTime: 'Total Distance / Time',
      totalCost: 'Total Cost',
      hideSummary: 'Hide Summary',
      showSummary: 'Show Summary',
      approveRequest: 'Approve Request',
      deleteReservation: 'Delete Reservation',
      endRental: 'End Rental',
      by: 'by {name}',
      approvedAutomatically: 'The request was approved automatically.',
      noEvents: 'No events yet',
      eventsFailed: 'Rental events could not be loaded.',
      events: {
        requestReceived: 'Request received',
        approved: 'Approved',
        declined: 'Declined',
        canceledByRider: 'Canceled by Rider',
        canceledByAdmin: 'Canceled by Admin',
        canceledBySystem: 'Canceled by System',
        rentalEnded: 'Rental ended',
        internalDamageReported: 'Internal Damage Reported',
        outerDamageReported: 'Outer Damage Reported',
        endedByAdmin: 'Ended by Admin',
      },
    },
  },
  tracking: {
    title: 'Tracking',
    loadFailed: 'Tracking data could not be loaded.',
    tabs: {
      ALL: 'All',
      OVERDUE: 'Overdue',
      ACTIVE: 'Active',
      AVAILABLE: 'Available',
      OUT_OF_SERVICE: 'Out of Service',
    },
    list: {
      searchPlaceholder: 'Vehicle ID',
      noVehicles: 'No vehicles found',
      hide: 'Hide vehicle list',
      show: 'Show vehicle list',
    },
    card: {
      status: 'Status',
      drivers: 'Driver(s)',
      next: 'Next: {time}',
      last: 'Last: {status} {time}',
      lastStatus: {
        COMPLETED_ON_TIME: 'Completed',
        RETURNED_LATE: 'Returned Late',
        ENDED_BY_ADMIN: 'Ended by Admin',
      },
      noRentalsToday: 'No rentals today',
      noRentalsOnDate: 'No rentals on this date',
      oneRental: '1 rental',
      rentals: '{count} rentals',
      outOfService: 'Out of Service',
      outOfServiceUntil: 'Out of Service until {until}',
      noTelematics: 'No telematics data',
    },
    map: {
      currentStatusNote: 'Pins show current vehicle status',
    },
    popup: {
      serviceStatus: 'Service Status',
      operationalStatus: 'Operational Status',
      vehicleState: 'Vehicle State',
      nextReservationIn: 'Next Reservation in',
      fuel: 'Fuel',
      lastUpdate: 'Last update',
      inService: 'In Service',
      outOfService: 'Out of Service',
      outOfServiceUntil: 'Out of Service until {until}',
      plannedOutOfService: 'Out of Service from {start} until {until}',
      rented: 'Rented',
      available: 'Available',
      ignitionOn: 'Ignition on',
      ignitionOff: 'Ignition off',
      withRequested: '{duration} (Requested)',
      fuelValue: '{volume} {unit} ({percent})',
      units: {
        gallon: 'gal',
        litre: 'L',
      },
      viewVehicleDetail: 'View Vehicle Detail',
      close: 'Close',
    },
    kpis: {
      totalRentals: 'Total Rentals',
      pendingRequests: 'Pending Requests',
      completedOnTime: 'Completed on Time',
      returnedLate: 'Returned Late',
    },
    grid: {
      noRentals: 'No rentals on this date',
      noMatches: 'No rentals matching the selected filters',
    },
    columns: {
      requestTime: 'Request Time',
      endedBy: 'Ended By',
      endNote: 'End Note',
      adminNote: 'Admin Note',
    },
  },
  vehicles: {
    title: 'Vehicles',
    searchPlaceholder: 'Search by license plate, vehicle name or Chassis Number',
    loadFailed: 'Vehicles could not be loaded.',
    columns: {
      licensePlate: 'License Plate',
      withUnit: '{label} ({unit})',
      deviceStatus: 'Device Status',
      lastLocationUpdate: 'Last Location Update',
      lastAddress: 'Last Address',
      lastUsageStart: 'Last Usages Start',
      lastUsageEnd: 'Last Usages End',
      registrationDate: 'Registration Date',
    },
    deviceStatus: {
      CONNECTED: 'Connected',
      DISCONNECTED: 'Disconnected',
      NEVER_CONNECTED: 'Never connected',
    },
  },
  vehicleDetail: {
    loadFailed: 'Vehicle details could not be loaded.',
    notFound: 'This vehicle could not be found. It may have been deleted.',
    tabs: {
      basicInfo: 'Basic Info',
      lastLocation: 'Last Location',
      damageReports: 'Damage Reports',
    },
    fields: {
      vehiclePlate: 'Vehicle Plate',
      vehicleName: 'Vehicle Name',
      serviceStatus: 'Service Status',
      outOfServiceStart: 'Start',
      outOfServiceUntil: 'Until',
      outOfServiceReason: 'Reason',
      modules: 'Modules',
      sharedFleet: 'Shared Fleet',
      operationalStatus: 'Operational Status',
      sharedFleetUsage: 'Shared Fleet Usage',
      odometer: 'Odometer',
      fuelLevel: 'Fuel Level',
      batteryVoltage: 'Battery Voltage',
      phoneNumber: 'Phone Number',
      deviceType: 'Device Type',
      deviceImei: 'Device IMEI',
      gsmAccountProvider: 'GSM Account Provider',
      gsmAccountNumber: 'GSM Account Number',
      parkingLot: 'Parking Lot',
      wheelchairEnabled: 'Wheelchair Enabled',
      transmissionType: 'Transmission Type',
      category: 'Category',
      make: 'Make',
      model: 'Model',
      color: 'Color',
      year: 'Year',
      chassisNumber: 'Chassis Number',
      capacity: 'Capacity',
      bikeCapacity: 'Bike Capacity',
      wheelchairCapacity: 'Wheelchair Capacity',
      avgEmissionsPerMile: 'Avg. Emissions per Mile',
      avgEmissionsPerKm: 'Avg. Emissions per km',
    },
    values: {
      inService: 'In Service',
      outOfService: 'Out of Service',
      outOfServiceLine: 'Out of Service, {start} – {until}, {reason}, {admin}',
      rented: 'Rented',
      available: 'Available',
      yes: 'Yes',
      no: 'No',
      automatic: 'Automatic',
      manual: 'Manual',
      viewRentals: 'View Rentals',
    },
    lastLocation: {
      noLocation: 'No telematics data',
    },
    damages: {
      outer: 'Outer ({count})',
      internal: 'Internal ({count})',
      reportedOn: 'Reported on {date}',
      reportedAtPickup: 'Reported at Pick-up on {date}',
      reportedAtDropoff: 'Reported at Drop-off on {date}',
      by: 'by {name}',
      viewRental: 'View Rental',
      viewMore: 'View more',
      viewLess: 'View less',
      fixedOn: 'Fixed on {date} by {name}',
      markFixed: 'Mark as Fixed',
      undo: 'Undo',
      fixTitle: 'Damage Fixed',
      fixMessage: "Confirm if you'd like to mark the reported damage as fixed.",
      undoTitle: 'Mark as Not Fixed',
      undoMessage:
        "Confirm if you'd like to mark this damage as not fixed. It will be counted as an active damage on this " +
        'vehicle again.',
      confirm: 'Confirm',
      fixFailed: 'The damage could not be updated. Please try again.',
      errors: {
        vehicleNotFound: 'This vehicle could not be found.',
        damageNotFound: 'This damage was not found on this vehicle.',
      },
      rentalNotFound: 'The rental could not be opened.',
      previousPhoto: 'Previous photo',
      nextPhoto: 'Next photo',
      photoTitle: {
        outer: 'Outer damage',
        internal: 'Internal damage',
      },
    },
    doors: {
      lock: 'Lock Doors',
      unlock: 'Unlock Doors',
      lockMessage: 'This will lock the doors. Are you sure you want to continue?',
      unlockMessage: 'This will unlock the doors. Are you sure you want to continue?',
      continue: 'Continue',
      rentedTitle: 'The vehicle is currently rented.',
      rentedMessage: 'You must end the rental before sending a door command.',
      lockSent: 'Lock command sent to the vehicle.',
      unlockSent: 'Unlock command sent to the vehicle.',
      lockFailed: 'Doors could not be locked. Please try again.',
      unlockFailed: 'Doors could not be unlocked. Please try again.',
      errors: {
        noDevice: 'This vehicle has no remote door device.',
        lockNotSent: 'The lock command could not be sent to the vehicle.',
        unlockNotSent: 'The unlock command could not be sent to the vehicle.',
      },
    },
    deviceTypes: {
      NONE: 'None',
      BASIC_TELEMATIC: 'Basic Telematic',
      REMOTE_DOOR: 'Remote Door',
    },
    form: {
      editTitle: 'Edit Vehicle',
      version: 'Version',
      saved: 'Vehicle saved.',
      saveFailed: 'The vehicle could not be saved. Please try again.',
      plateExists: 'A vehicle with this plate already exists.',
      checkFields: 'Some values were not accepted. Please check the fields and try again.',
      refreshRetry: 'The vehicle, parking lot or model is no longer available. Please refresh and try again.',
      capacityMin: 'Capacity must be at least 2.',
      wheelchairCapacityRequired: 'Wheelchair Capacity must be greater than 0 for a wheelchair enabled vehicle.',
      wheelchairCapacityZero: 'Wheelchair Capacity must be 0 unless the vehicle is wheelchair enabled.',
      noCatalog: 'No vehicle model matches this make, model, year and transmission type.',
      parkingLotLocked:
        'The vehicle has upcoming reservations. Reassign them to other vehicles to change the parking lot.',
      parkingLotChecking: "Checking the vehicle's upcoming reservations...",
      parkingLotUnchecked:
        "The vehicle's upcoming reservations could not be checked, so the parking lot cannot be changed now.",
      parkingLotRetry: 'Try again',
      lookupsFailed: 'The form options could not be loaded. Please try again.',
      startInPast: 'Start cannot be in the past.',
      untilAfterStart: 'Until must be after Start.',
      noCategories: 'No categories defined',
      moduleRequired: 'Choose at least one module.',
      plateDeleted: 'A deleted vehicle has this plate, so it cannot be used.',
      serviceStatusFixed:
        'A new vehicle is added Out of Service. An admin who can change vehicle status can put it in service.',
      // New Vehicle's save: the vehicle is added, then found in the list and put in service when In Service was chosen
      created: 'Vehicle added.',
      createdNotInService: 'The vehicle was added but could not be put in service. It stays Out of Service.',
      createdNotFound: 'The vehicle was added but is not in the vehicle list yet. Refresh the page to see it.',
      createdNotFoundNotInService:
        'The vehicle was added but is not in the vehicle list yet, so it could not be put in service and stays Out ' +
        'of Service. Refresh the page to see it.',
      units: {
        lb: 'lb',
        g: 'g',
      },
      outOfServiceReasons: {
        MAINTENANCE: 'Maintenance',
        REPAIR_DAMAGE: 'Repair / Damage',
        ACCIDENT: 'Accident',
        CLEANING: 'Cleaning',
        INSPECTION: 'Inspection',
        STOLEN: 'Stolen',
        OTHER: 'Other',
      },
    },
    // the warnings before a save that affects the vehicle's rentals; '|' separates one reservation from several
    saveWarning: {
      endRental: {
        title: 'End Current Rental?',
        message:
          'This vehicle is currently rented by {driver} until {dropoff}. To mark it Out of Service, the rental ' +
          'will be ended now and the driver will be notified.',
        confirm: 'End Rental and Save',
      },
      reservations: {
        title: 'Reservations Exist for This Period',
        message:
          'This vehicle has 1 reservation between {start} and {until}. To mark it Out of Service, the reservation ' +
          'will be canceled and the rider will be notified. To keep it, go back and reassign it to another vehicle ' +
          'first. | This vehicle has {count} reservations between {start} and {until}. To mark it Out of Service, ' +
          'they will be canceled and riders will be notified. To keep them, go back and reassign them to other ' +
          'vehicles first.',
        messageWithRental:
          'This vehicle is currently rented by {driver} until {dropoff} and has 1 reservation between {start} and ' +
          '{until}. To mark it Out of Service, the current rental will be ended and the reservation will be ' +
          'canceled. Riders will be notified. To keep the reservation, go back and reassign it to another vehicle ' +
          'first. | This vehicle is currently rented by {driver} until {dropoff} and has {count} reservations ' +
          'between {start} and {until}. To mark it Out of Service, the current rental will be ended and the ' +
          'reservations will be canceled. Riders will be notified. To keep the reservations, go back and reassign ' +
          'them to other vehicles first.',
        confirm: 'Cancel 1 Reservation and Save | Cancel {count} Reservations and Save',
        confirmWithRental:
          'End Rental, Cancel 1 Reservation and Save | End Rental, Cancel {count} Reservations and Save',
      },
      removeSharedFleet: {
        title: 'Remove Vehicle from Shared Fleet?',
        message:
          'This vehicle has 1 upcoming Shared Fleet reservation. Removing it from Shared Fleet will cancel the ' +
          'reservation and notify the rider. To keep it, go back and reassign it to another vehicle first. A ' +
          'current rental, if any, will continue until it ends. | This vehicle has {count} upcoming Shared Fleet ' +
          'reservations. Removing it from Shared Fleet will cancel all of them and notify riders. To keep them, go ' +
          'back and reassign them to other vehicles first. A current rental, if any, will continue until it ends.',
        confirm: 'Cancel 1 Reservation and Save | Cancel {count} Reservations and Save',
      },
      goBack: 'Go Back',
      checkFailed: "The vehicle's rentals could not be checked, so the changes cannot be saved now. Please try again.",
    },
  },
};
